export default __webpack_public_path__ + "static/media/ventil2.56dd12f0.jpg";